// @flow

import type { BasicProps, EasyCompMap, PropsSchema } from '../../type'

import * as React from 'react'
import computeData from '../hoc/computeData'
import { customRender } from '../EasyCompComponent'

type Props = BasicProps & {
  customProps: any,
  children?: Array<EasyCompMap>,
  propsName?: string,
  schema: any,
  events: any
};

@computeData({ includeData: true, includeVisible: false })
export default class DataHandler extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      type: 'code',
      key: 'schema',
      title: '配置信息'
    },
    'separator',
    {
      key: 'propsName',
      type: 'text',
      title: '属性名称'
    }
  ];

  get$comp = () => {
    const { schema, jsEnv, events } = this.props
    let $comp = { events }
    if (schema) {
      let jsonSchema = schema
      if (typeof schema === 'string') {
        jsonSchema = jsEnv.runCode(schema)
      }
      if (Array.isArray(jsonSchema)) {
        jsonSchema.forEach(item => {
          if (item && item.key) {
            $comp[item.key] = this.props[item.key]
          }
        })
      }
    }
    return $comp
  };

  render () {
    const {
      children,
      jsEnv,
      customProps: parentCustomProps = {},
      propsName
    } = this.props
    if (!children) {
      return null
    }
    const { $propsNames = [] } = parentCustomProps
    let compData = jsEnv.getComponentData()
    compData.$compConfig = this.get$comp()
    let customProps = {
      ...compData,
      $propsNames: [...$propsNames]
    }
    $propsNames.forEach(key => {
      customProps[key] = parentCustomProps[key]
    })
    if (propsName) {
      customProps.$propsNames.push(propsName)
      customProps[propsName] = {
        ...compData
      }
    }
    return customRender(
      children,
      {
        customProps
      },
      customProps.$indexes
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/program/CustomPropsConfig.js